import { Component, inject, Input, OnInit } from '@angular/core';
import {UserService} from '../../../services/user.service';
import {UserVO} from '../../../generate/UserVO';

@Component({
    selector: 'user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.scss'],
    standalone: false
})
export class UserProfileComponent implements OnInit {
  user: UserVO;

  @Input()
  signUpMode: Boolean = false;
  editMode: boolean;

  private userService: UserService = inject(UserService);


  ngOnInit(): void {
    this.getUserDetails();
    if (this.signUpMode) {
      this.editMode = true;
    }
  }

  enableEditMode() {
    this.editMode = true;
  }

  private getUserDetails() {

    this.userService.getCurrentUser().subscribe({
      next: (user) => {
        this.user = user as UserVO;
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
       // empty
      }
    });
  }

  disableEditMode() {
    this.editMode = false;
    this.getUserDetails();
  }
}
